export default {

	init(){

		function NewsLetterMailChimp( container ) {

			function removeCallBack( message, status = 'error' ) {

				callback = container.querySelectorAll('.sendCallBack');

				if( callback.length > 0 )  {

					callback.forEach( function( box, index ){
						box.remove();
					});

				}

				container.querySelector('.row__form .newsLetterSubmit').insertAdjacentHTML('beforebegin', '<p class="sendCallBack '+status+'">'+message+'</p>' );

			}

			var button = container.querySelector('.newsLetterSubmit');
			var formSubmit = false;	

			var requestData = [];
			var response;

			var agreements;
			var empty;

			// -- Callback message -- // 

				var callback;
				var callbackSendError = container.getAttribute('data-error');
				var callbackSendSuccess = container.getAttribute('data-success');
				var callbackFieldsEmpty = container.getAttribute('data-empty');

			// -- END -- // 

			button.addEventListener('click',function() {

				if( !button.classList.contains('disable') && formSubmit == false ) {

					button.classList.add('disable');

					agreements = container.querySelectorAll('.formField');

					var input;
					agreements.forEach( function( field, index ) {

						input = field.querySelector('input');

						if( input.getAttribute('type') == 'checkbox' ) {

							if( !input.checked ) {

								field.classList.add('empty');

							} else {

								field.classList.remove('empty');

							}

						} else if( input.getAttribute('type') == 'email' ) {

							if( !input.value ) {

								field.classList.add('empty');

							} else {

								field.classList.remove('empty');

							}

						}

					});

					empty = container.querySelectorAll('.formField.empty');

					if( empty.length == 0 ) {

						// -- Request data -- // 

							requestData.push('action=newsLetter');
							requestData.push('security='+container.querySelector('input#authorize').value);
							requestData.push('email='+container.querySelector('.form__input .input__email').value);

							requestData = requestData.join('&');

						// -- END -- // 


						var request = new XMLHttpRequest();

						request.onreadystatechange = function() {

							if( request.responseText ) {

								response = JSON.parse(request.responseText);

								if( response.status == 'success' ) {

									removeCallBack(callbackSendSuccess, 'success');
									formSubmit = true;
									container.querySelector('.form__input .input__email').value = '';

								} else if( response.status == 'error' ) {

									removeCallBack(callbackSendError, 'error');
									button.classList.remove('disable');

								}

							}

						}

						// Set up our request
						request.open('POST', document.querySelector('footer').getAttribute('data-endpoint') );

						// Add the required HTTP header for form data POST requests
						request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

						// Finally, send our data.
						request.send(requestData);
						

					} else {

						removeCallBack( callbackFieldsEmpty, 'error' );
						button.classList.remove('disable');

					}

				}

			});

		}

		var container = document.querySelector('.newsLetter');

		if( container ) {

			NewsLetterMailChimp( container );

		}

	},
	finalize() {

	}

}